<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/blocked-wallet.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Name Doesn't match</div>
  
      <div class="subtitle">
        The name on your bank account
        doesn’t match your the one on your
        MoMo profile. 
        Any money taken has been
        refunded to your bank account.
      </div>
    </div>
  
    <!-- BUTTON -->
    <footer class="screen-footer">
      <button
        pButton
        label="DONE"
        class="retry-btn"
        (click)="done()"
      ></button>
    </footer>
  
  </div>